<template>
  <div class="container-fluid">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-7">
        <img id="logo-orisha" class="d-block"
             src="https://medias.bimedia-it.com/assets/logo_orisha_rs_blanc.svg"/>
        <div class="card card-orisha">
          <div class="card-header">
            <h1 class="text-center my-1 col-10 mx-auto title-balanced">
              Créer mon compte Orisha
            </h1>
          </div>
          <div class="card-body">
            <p class="text-center dev-text-spacing">
              Merci de choisir un identifiant et un mot de passe afin de créer votre compte
              Orisha associé au mail <b>{{email}}</b>
            </p>
            <RegisterForm :email="email" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import RegisterForm from '../components/form/RegisterForm.vue';

export default {
  name: 'Register',
  data() {
    return {
      // Token de vérification
      token: this.$route.query.token,
      email: this.$route.query.mail,
      source: undefined,
    };
  },
  created() {
    axios.post('/auth/api/front/token', JSON.stringify({
      token: this.token,
    }), { headers: { 'content-type': 'application/json' } })
      .then((res) => {
        this.source = res.data.source;
      })
      .catch(() => {
        this.$router.push({ name: 'Error', params: { errorType: 'token' } });
      });
  },
  components: {
    RegisterForm,
  },
};
</script>

<style scoped>
.title-balanced {
  text-wrap: balance;
}
</style>
